import { LightningBoltIcon } from '@/components/icons/lightning-bolt';
import { Tooltip } from '@/components/ui/tooltip';

type FlashAlertProps = {
  description: string;
};

export function FlashAlert({ description }: FlashAlertProps) {
  return (
    <Tooltip content={description}>
      <span>
        <LightningBoltIcon className="text-amber-600" />
      </span>
    </Tooltip>
  );
}
